import Vue from 'vue'
import Router from 'vue-router'
// 路由的懒加载效果
const Search = () => import('../pages/search.vue')
const Detail = () => import('../pages/detail.vue')


Vue.use(Router)

export default new Router({
  routes: [
    { path: "/", redirect: "/search" }, ///重定向到登录页
    {
      path: "/search",
      name: "search",
      component: Search
    },
    {
      path: "/detail",
      name: "detail",
      component: Detail
    },
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js